<template>
  <v-dialog v-model="isActive" persistent scrollable max-width="500">
    <ValidationObserver ref="obs" v-slot="{ passes }">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Responder encuesta
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense>
                <!-- <v-col cols="12">
                    <ValidationProvider
                      name="nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        dense
                        filled
                        rounded
                        required
                        autofocus
                        type="text"
                        color="info"
                        name="nombre"
                        class="rounded-small"
                        label="Nombre completo"
                        prepend-inner-icon="mdi-account"
                        v-model.trim="payload.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col> -->

                <!-- <v-col cols="12">
                  <ValidationProvider
                    name="correo"
                    rules="email|required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      dense
                      filled
                      rounded
                      required
                      type="text"
                      color="info"
                      name="email"
                      class="rounded-small"
                      label="Correo electrónico"
                      prepend-inner-icon="mdi-email"
                      v-model="payload.email"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col> -->

                <v-col cols="12">
                  <ValidationProvider
                    name="descripción"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      filled
                      rounded
                      required
                      auto-grow
                      type="text"
                      color="info"
                      name="descripcion"
                      label="Descripción"
                      class="rounded-small"
                      v-model.trim="payload.description"
                      :error-messages="errors"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closedialog('cerrar')"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="passes(sendform)"
              >Añadir</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";

export default {
  components: {
    vuescroll,
  },

  props: ["isActive", "surveyID"],

  data() {
    return {
      isLoading: false,
      payload: {
        name: "",
        description: "",
        survey_id: null,
        email: "",
        type: 2,
      },
      // options: [
      //   {
      //     value: 2,
      //     label: "Supervisor",
      //   },
      //   {
      //     value: 3,
      //     label: "Agente",
      //   },
      // ],
    };
  },

  methods: {
    closedialog(newData) {
      this.$emit("close:dialog", newData);
    },

    resetform() {
      this.payload = {
        name: "",
        description: "",
        survey_id: null,
        email: "",
        type: null,
      };
    },

    async sendform() {
      // /surveys/response_survey
      this.isLoading = true;

      try {
        this.payload.survey_id = this.surveyID;

        const { data } = await PbxHttpClient.post(
          "/surveys/response_survey",
          this.payload
        );

        this.$snotify.info(
          `Datos guardados con éxito. Puede continuar con la encuesta.`
        );

        this.$router.push({
          name: "Completar formulario",
          params: { surveyID: this.surveyID, userID: data.respuesta.id },
        });
      } catch (err) {
        this.$snotify.error(err.response?.data?.error, "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
